// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"32d8c4a5","407":"20013390","494":"29ac7aa2","725":"c7348856"}[chunkId] + ".chunk.css";
};